/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Visa_Eb5_Point_0_LabelInputs */

const en_visa_eb5_point_0_label = /** @type {(inputs: Visa_Eb5_Point_0_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Investment Structure`)
};

const pt_visa_eb5_point_0_label = /** @type {(inputs: Visa_Eb5_Point_0_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estrutura de Investimento`)
};

const es_visa_eb5_point_0_label = /** @type {(inputs: Visa_Eb5_Point_0_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estructura de Inversión`)
};

/**
* | output |
* | --- |
* | "Investment Structure" |
*
* @param {Visa_Eb5_Point_0_LabelInputs} inputs
* @param {{ locale?: "en" | "pt" | "es" }} options
* @returns {LocalizedString}
*/
export const visa_eb5_point_0_label = /** @type {((inputs?: Visa_Eb5_Point_0_LabelInputs, options?: { locale?: "en" | "pt" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Visa_Eb5_Point_0_LabelInputs, { locale?: "en" | "pt" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt") return pt_visa_eb5_point_0_label(inputs)
	if (locale === "es") return es_visa_eb5_point_0_label(inputs)
	return en_visa_eb5_point_0_label(inputs)
});